import React, { useState, useContext, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "../../../../axios/index";
import { Link } from "react-router-dom";

// Context
import { UserContext } from "./../../../Context/UserContextProvider";

// styles
import styles from "./AddMeeting.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css";
import "react-toastify/dist/ReactToastify.css";

// Re Useable Components
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import AddMeetingInput from "../Input/AddMeetingInput";
import DatePickerInput from "./../Input/DatePickerInput";
import AddMeetingInviteInput from "../Input/AddMeetingInviteInput";
import AddMeetingInputDropDown from "../Input/AddMeetingInputDropDown";
import { addMeetingValidate } from "./addMeetingValidate";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import opacity from "react-element-popper/animations/opacity";

// MUI
import Checkbox from "@mui/material/Checkbox";

//Images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg";

const AddMeeting = () => {
  const { userToken } = useContext(UserContext);
  const history = useHistory();
  const [modalShow, setModalShow] = useState(false);
  const [invitedPeople, setInvitedPeople] = useState([]);
  const [errors, setErrors] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const [users, setUsers] = useState([]);
  const [meetingInfo, setMeetingInfo] = useState({
    title: "",
    manager: "",
    managerID: "",
    supervisor: "",
    supervisorID: "",
    meetingResponsible: "",
    meetingResponsibleID: "",
    meetingLocation: "",
    description: "",
    meetingOrder: "",
    reminder: false,
  });

  useMemo(() => users, [users]);

  useEffect(() => {
    const getData = async () => {
      const getApiData = await axios.get("Meeting/GetUserDropDonw?permissions=16&permissions=18&permissions=19", {
        headers: { authorization: "Bearer " + userToken },
      });
      setUsers(getApiData.data.data);
    };
    getData();
  }, [userToken]);

  useEffect(() => {
    setErrors(addMeetingValidate(meetingInfo, date, time, invitedPeople));
  }, [meetingInfo, date, time, invitedPeople]);

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      <style type="text/css">
        {`
                .rmdp-wrapper  {
                    background: #F9F9F9 !important;
                }

                .rmdp-arrow {
                    border-color: #D9D9D9 !important;
                }

                `}
      </style>

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-9">
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover={false}
              theme="light"
            />
            <form onSubmit={e => e.preventDefault()} className={`mt-3 px-0 position-relative ${Dstyles.container}`}>
              <DashboardHeader onClick={() => setModalShow(true)} />

              {/* head title */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-center justify-content-md-start flex-wrap mt-2 mb-2">
                      <a href="#" onClick={history.goBack}>
                        <img className="ms-2" src={arrowIcon} alt="icon" />
                      </a>
                      <div className={Dstyles.text1}>افزودن جلسه</div>
                    </div>
                  </div>
                </div>
              </div>
              {/* head title */}

              {/* inputs row1 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap">
                      <AddMeetingInput title="عنوان جلسه" inputName="title" inputValue={meetingInfo.title} onChange={changeHandler} />
                      <AddMeetingInputDropDown
                        users={users}
                        defaultText="رئیس جلسه"
                        inputName="manager"
                        selectedItem={meetingInfo.manager}
                        setState={setMeetingInfo}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row1 */}

              {/* inputs row2 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap">
                      <AddMeetingInputDropDown
                        users={users}
                        defaultText="ناظر"
                        inputName="supervisor"
                        selectedItem={meetingInfo.supervisor}
                        setState={setMeetingInfo}
                      />

                      <AddMeetingInputDropDown
                        users={users}
                        defaultText="مسئول صورت جلسه"
                        inputName="meetingResponsible"
                        selectedItem={meetingInfo.meetingResponsible}
                        meetingResponsible
                        setState={setMeetingInfo}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row2 */}

              {/* inputs row3 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap">
                      <DatePickerInput date={date} setDate={setDate} />
                      <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                        <div className="d-flex align-items-start justify-content-center flex-column my-0 w-100">
                          <div className={`mb-2 ${styles.input_top_title}`}>انتخاب زمان</div>
                          <DatePicker
                            value={time}
                            onChange={timeHandler}
                            disableDayPicker
                            format="HH:mm"
                            plugins={[<TimePicker hideSeconds />]}
                            calendar={persian}
                            locale={persian_fa}
                            calendarPosition="bottom-center"
                            animations={[opacity()]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row3 */}

              {/* inputs row4 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex align-items-center justify-content-center flex-wrap">
                      <AddMeetingInput
                        title="مکان جلسه"
                        inputName="meetingLocation"
                        inputValue={meetingInfo.meetingLocation}
                        onChange={changeHandler}
                        fullWidth
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row4 */}

              {/* inputs row4 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start mb-4">
                      <div className={`mb-3 ${styles.input_top_title}`}>توضیح</div>
                      <textarea
                        type="text"
                        name="description"
                        className={`w-100 px-3 pt-3 ${styles.textarea}`}
                        onChange={changeHandler}
                        value={meetingInfo.description}></textarea>
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row4 */}

              {/* inputs row5 */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex flex-column justify-content-center align-items-start mb-4">
                      <div className={`mb-3 ${styles.input_top_title}`}>دستور جلسه</div>
                      <textarea
                        type="text"
                        name="meetingOrder"
                        className={`w-100 px-3 pt-3 ${styles.textarea}`}
                        onChange={changeHandler}
                        value={meetingInfo.meetingOrder}></textarea>
                    </div>
                  </div>
                </div>
              </div>
              {/* inputs row5 */}

              {/* row6 */}
              <AddMeetingInviteInput InviteInput invitedPeople={invitedPeople} setInvitedPeople={setInvitedPeople} />
              {/* row6 */}

              {/* reminder  */}
              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 me-3" dir="rtl">
                    <div className="w-100 d-flex justify-content-start align-items-center mb-4">
                      <Checkbox checked={meetingInfo.reminder} name="reminder" onChange={changeHandler} inputProps={{ "aria-label": "controlled" }} />
                      <div className={styles.text_md_bold}>یادآوری جلسه برای نفرات دعوت شده در روز برگزاری.</div>
                    </div>
                  </div>
                </div>
              </div>
              {/* reminder  */}

              <div className="py-2">
                <div className="container-fluid">
                  <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-0 ms-3" dir="rtl">
                    <div className="w-100 d-flex justify-content-end align-items-center mb-4">
                      {btnLoader ? (
                        <div className={Dstyles.btn_loader_container}>
                          <div className={Dstyles.btn_spinner}></div>
                        </div>
                      ) : (
                        <button className={`btn ${styles.submit_btn}`} type="submit" onClick={submitHandler}>
                          ذخیره
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="col-md-3">
            {/* sideMenu starts */}
            <DashboardSideMenu meeting addMeeting />
            {/* sideMenu ends */}
          </div>
        </div>
      </div>
    </>
  );

  function changeHandler(event) {
    if (event.target.name === "reminder") {
      setMeetingInfo(prev => {
        return { ...prev, [event.target.name]: event.target.checked };
      });
    } else {
      setMeetingInfo(prev => {
        return { ...prev, [event.target.name]: event.target.value };
      });
    }
  }

  async function timeHandler(value) {
    setTime(value);
    if (openMenu === true) {
      setOpenMenu(false);
    }
    // const userDate = `${value.hour}-${value.minute}`
    // console.log(userDate)
  }

  function submitHandler() {
    if (!Object.keys(errors).length) {
      notify("درحال ایجاد جلسه جدید", "success");
    } else {
      notify("!لطفا تمام فیلد هارا پرکنید", "error");
    }
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      postHandler();
    } else if (type === "successed") {
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function postHandler() {
    try {
      setBtnLoader(true);
      // notify("درحال ایجاد جلسه", "successed")
      const userDate = `${date.year}/${date.month}/${date.day}`;
      const userTime = `${time.hour}:${time.minute}:${time.second}`;
      var data = new FormData();
      data.append("Title", meetingInfo.title);
      data.append("Description", meetingInfo.description);
      data.append("MeetingDate", userDate);
      data.append("MeetingTime", userTime);
      data.append("Address", meetingInfo.meetingLocation);
      data.append("MeetingLeader", meetingInfo.manager);
      data.append("MeetingLeaderId", meetingInfo.managerID);
      for (const usersID of invitedPeople) {
        data.append("ConsultantIds", usersID.id);
      }
      data.append("Spectator", meetingInfo.supervisor);
      data.append("SpectatorId", meetingInfo.supervisorID);
      data.append("Reporter", meetingInfo.meetingResponsible);
      data.append("ReporterId", meetingInfo.meetingResponsibleID);
      for (const userName of invitedPeople) {
        data.append("Invitees", userName.userName);
      }
      data.append("Agenda", meetingInfo.meetingOrder);
      data.append("IsRemind", meetingInfo.reminder);

      const apiData = await axios.post("Meeting", data, {
        headers: { authorization: "Bearer " + userToken },
      });
      notify("جلسه با موفقیت ایجاد شد", "successed");
      // console.log(apiData);
      history.push("/meeting-archive");
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }
};

export default AddMeeting;
